<template>
  <article class="ai-suggestion">
    <header class="ai-suggestion__header">
      <div>
        <h3 class="ai-suggestion__title">
          {{ suggestion.field_label || suggestion.field_key }}
        </h3>
        <p class="ai-suggestion__meta">
          {{ suggestion.field_key }}
          <span v-if="suggestion.confidence !== null">
            · confidence {{ formatConfidence(suggestion.confidence) }}
          </span>
        </p>
      </div>
      <v-chip :color="suggestionStatusColor(suggestion.decision_status)">
        {{ formatSuggestionStatus(suggestion.decision_status) }}
      </v-chip>
    </header>

    <div class="ai-diff-grid">
      <div class="ai-diff-block">
        <span class="ai-diff-block__label">Valoare curentă CRM</span>
        <pre class="ai-diff-block__value">{{ formatValueBlock(suggestion.current_live_value ?? suggestion.current_value_json) }}</pre>
      </div>
      <div class="ai-diff-block ai-diff-block--accent">
        <span class="ai-diff-block__label">Sugestie AI</span>
        <pre class="ai-diff-block__value">{{ formatValueBlock(resolveSuggestedValue(suggestion)) }}</pre>
      </div>
    </div>

    <p v-if="suggestion.reason_text" class="ai-suggestion__reason">
      {{ suggestion.reason_text }}
    </p>
    <p v-if="!suggestion.is_supported" class="ai-suggestion__warning">
      Sugestia este păstrată pentru audit, dar nu este suportată pentru apply în CRM.
    </p>

    <div v-if="isEditing" class="ai-editor">
      <v-textarea
        :model-value="editingValue"
        rows="4"
        auto-grow
        label="Valoare editată"
        hide-details
        @update:model-value="$emit('update:editingValue', $event)"
      />
      <div class="ai-action-row">
        <v-btn
          color="primary"
          :loading="actionLoading === `edit-${suggestion.id}`"
          @click="$emit('save-edit', suggestion)"
        >
          Salvează editarea
        </v-btn>
        <v-btn variant="text" @click="$emit('cancel-edit')">Anulează</v-btn>
      </div>
    </div>

    <div v-else class="ai-action-row">
      <v-btn
        variant="tonal"
        color="primary"
        :disabled="!suggestion.is_supported || suggestion.decision_status === 'applied'"
        :loading="actionLoading === `approve-${suggestion.id}`"
        @click="$emit('approve', suggestion)"
      >
        Aprobă
      </v-btn>
      <v-btn
        variant="tonal"
        color="secondary"
        :disabled="!suggestion.is_supported || suggestion.decision_status === 'applied'"
        @click="$emit('start-edit', suggestion)"
      >
        Editează
      </v-btn>
      <v-btn
        variant="text"
        color="error"
        :disabled="suggestion.decision_status === 'applied'"
        :loading="actionLoading === `reject-${suggestion.id}`"
        @click="$emit('reject', suggestion)"
      >
        Respinge
      </v-btn>
    </div>
  </article>
</template>

<script>
import {
  formatValueBlock,
  formatSuggestionStatus,
  suggestionStatusColor,
  formatConfidence,
} from "./aiWorkspaceShared.mjs";

export default {
  name: "AiReviewSuggestionCard",
  props: {
    suggestion: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    editingValue: {
      type: String,
      default: "",
    },
    actionLoading: {
      type: String,
      default: "",
    },
  },
  emits: [
    "approve",
    "reject",
    "start-edit",
    "cancel-edit",
    "save-edit",
    "update:editingValue",
  ],
  methods: {
    formatValueBlock,
    formatSuggestionStatus,
    suggestionStatusColor,
    formatConfidence,
    resolveSuggestedValue(suggestion) {
      if (suggestion.decision_status === "edited" && suggestion.edited_value_json !== null) {
        return suggestion.edited_value_json;
      }
      return suggestion.suggested_value_json;
    },
  },
};
</script>
